var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVacancyType({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.81299 8.37134C2.81299 5.54291 2.81299 4.1287 3.69167 3.25002C4.57035 2.37134 5.98456 2.37134 8.81299 2.37134H10.313C13.1414 2.37134 14.5556 2.37134 15.4343 3.25002C16.313 4.1287 16.313 5.54291 16.313 8.37134V11.3713C16.313 14.1998 16.313 15.614 15.4343 16.4927C14.5556 17.3713 13.1414 17.3713 10.313 17.3713H8.81299C5.98456 17.3713 4.57035 17.3713 3.69167 16.4927C2.81299 15.614 2.81299 14.1998 2.81299 11.3713V8.37134Z",
    stroke: "#44546F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56299 8.37134H12.563",
    stroke: "#44546F",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56299 11.3713H10.313",
    stroke: "#44546F",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacancyType);
export default __webpack_public_path__ + "static/media/Vacancy_Type.e7043beacb4350ed6c1dd6c2ee2556d8.svg";
export { ForwardRef as ReactComponent };